export default "__VITE_ASSET__1f7d5b9c__"